import gql from 'graphql-tag';

export default gql`
  query ($codeSlug: String) {
    contents(filter: { codeSlug: $codeSlug }) {
      _id
      name
      codeSlug
      subject {
        _id
        name
      }
    }
  }
`;
